"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var Typography_1 = require("../../Typography");
var Utility_1 = require("../../Icons/Utility");
var Selectbox_1 = __importDefault(require("../Selectbox"));
var styles_1 = __importDefault(require("../Selectbox/styles"));
var styles_2 = __importDefault(require("./styles"));
var classnames_1 = __importDefault(require("classnames"));
var useSelectboxStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
var useStyles = (0, react_jss_1.createUseStyles)(styles_2.default);
// eslint-disable-next-line no-redeclare
var SplitSelectbox = function (_a) {
    var id = _a.id, className = _a.className, topLevelLabel = _a.label, disabled = _a.disabled, errorMessage = _a.errorMessage, helperText = _a.helperText, onGroupChange = _a.onGroupChange, options = _a.options, tooltip = _a.tooltip;
    var classes = useStyles();
    var selectBoxClasses = useSelectboxStyles();
    var errorState = !disabled && errorMessage;
    var classname = (0, classnames_1.default)(selectBoxClasses.root, className, disabled && selectBoxClasses.disabled);
    (0, react_1.useEffect)(function () {
        if (options.length < 2 || options.length > 3)
            console.warn('You must pass either 2 or 3 select objects. See https://mortar.policygenius.com for more details.');
    }, [options]);
    var initialState = {};
    options.forEach(function (field) {
        var fieldId = field.id, defaultValue = field.defaultValue;
        initialState[fieldId] = defaultValue !== null && defaultValue !== void 0 ? defaultValue : '';
    });
    var _b = (0, react_1.useState)(initialState), selectValues = _b[0], setSelectValues = _b[1];
    var renderSelectboxes = function () {
        return options.map(function (field, idx) {
            var fieldId = field.id, onChange = field.onChange;
            var lastSelectbox = idx === options.length - 1;
            var errorStateAriaAttributes = (function () {
                var aria = {};
                if (errorMessage) {
                    aria['aria-invalid'] = 'true';
                    aria['aria-describedby'] = "".concat(id, "_err");
                }
                return aria;
            })();
            var onSelectChange = function (e) {
                var _a;
                var newValues = __assign(__assign({}, selectValues), (_a = {}, _a[fieldId] = e.target.value, _a));
                setSelectValues(newValues);
                if (onGroupChange) {
                    onGroupChange(e, newValues);
                }
                if (onChange) {
                    onChange(e);
                }
            };
            return (react_1.default.createElement(Selectbox_1.default, __assign({}, field, errorStateAriaAttributes, { key: fieldId, className: (0, classnames_1.default)(classes.fieldWrapper, selectBoxClasses.root, errorState && classes.fieldError), disabled: disabled, onChange: onSelectChange, showLabel: !topLevelLabel, tooltip: !!tooltip && lastSelectbox ? tooltip : field.tooltip })));
        });
    };
    var ErrorMessage = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(selectBoxClasses.helpContainer, disabled && selectBoxClasses.disabled) },
            react_1.default.createElement(Utility_1.AlertWarning, { color: "warningAccessible", ariaHidden: true }),
            react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: "secondary", className: (0, classnames_1.default)(selectBoxClasses.help, selectBoxClasses.helpError) }, errorMessage)));
    };
    var HelpMessage = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(selectBoxClasses.helpContainer, disabled && selectBoxClasses.disabled) },
            react_1.default.createElement(Typography_1.UtilityText, { size: "xsmall", color: "secondary", className: selectBoxClasses.help }, helperText)));
    };
    var DisplayMessage = function () {
        if (errorState)
            return react_1.default.createElement(ErrorMessage, null);
        if (helperText)
            return react_1.default.createElement(HelpMessage, null);
        return null;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: "".concat(id, "-wrap"), className: classname },
            topLevelLabel && (react_1.default.createElement("div", { className: classes.labels },
                react_1.default.createElement(Typography_1.LabelText, { size: "large", className: classes.label }, topLevelLabel),
                tooltip)),
            react_1.default.createElement("div", { className: classes.selectBoxes }, renderSelectboxes())),
        react_1.default.createElement(DisplayMessage, null)));
};
exports.default = SplitSelectbox;
